// @ts-nocheck
/* eslint-enable */
import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

export const FlexArticle = styled.article`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  text-align: center;
`;

export const WidenText = styled.p`
  ${font.sm};
  ${stacked._1x}
  color: ${colors['$hpx-grey-600']};
`;

export const WidenSearchButton = styled(ButtonBase)`
  ${font.sm};
  height: 37px;
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  display: inline-flex;
  align-items: center;
  margin: auto;
  cursor: pointer;
`;

export const BoldText = styled.b`
  padding-left: 4px;
`;

export const NoListingsIcon = styled.img`
  ${stacked._3x};
`;
export const NoListingsFoundText = styled.p`
  ${font.md};
  color: ${colors['$hpx-grey-600']};
  text-align: center;
`;

export const AlertArticle = styled.article`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
`;

export const AlertText = styled.p`
  ${stacked._1x};
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  text-align: center;
`;
